import React from "react";
import Button from "../../../components/Button/Button.jsx";
import SectionCard from "../ui/SectionCard";
import Field from "../ui/Field";

import { FaIdCard, FaSave, FaSyncAlt } from "react-icons/fa";

const FUNCTION_OPTIONS = [
  { value: "", label: "— Sélectionner —" },
  { value: "Arbitres", label: "Arbitres" },
  { value: "Commissaires sportifs", label: "Commissaires sportifs" },
  { value: "Juges", label: "Juges" },
  { value: "Elus du C.A", label: "Elus du C.A" },
  { value: "Président de comité", label: "Président de comité" },
  { value: "Membre de commission", label: "Membre de commission" },
  { value: "Délégué de clubs", label: "Délégué de clubs" },
  { value: "Membre de l'ETR", label: "Membre de l'ETR" },
  { value: "Président de Ligue", label: "Président de Ligue" },
];

export default function ExpenseProfileCard({
  loading,
  saving,
  profile,
  draft,
  setDraft,
  onSave,
  onReload,
}) {
  return (
    <SectionCard
      id="profil"
      title="Coordonnées"
      subtitle="Ces informations seront mémorisées pour éviter de les ressaisir à chaque fiche."
      icon={<FaIdCard />}
      actions={
        <div className="flex flex-col gap-2">
          <Button
            text={saving ? "Enregistrement..." : "Enregistrer"}
            variant="primary"
            size="sm"
            onClick={onSave}
            icon={FaSave}
          />
          <Button
            text={loading ? "Chargement..." : "Rafraîchir"}
            variant="outline"
            size="sm"
            onClick={onReload}
            icon={FaSyncAlt}
          />
        </div>
      }
    >
      {loading ? (
        <div className="rounded-xl p-4 bg-slate-50 ring-1 ring-slate-200">
          Chargement du profil...
        </div>
      ) : (
        <>
          {profile ? (
            <div className="mb-4 text-xs text-slate-500">
              Profil déjà enregistré (id: {profile.id})
            </div>
          ) : (
            <div className="mb-4 rounded-xl p-3 bg-amber-50 text-amber-900 ring-1 ring-amber-200 text-sm">
              Première utilisation : merci de compléter vos coordonnées.
            </div>
          )}

          <div className="grid gap-4 md:grid-cols-2">
            <Field
              label="Nom *"
              value={draft.nom}
              onChange={(v) => setDraft((p) => ({ ...p, nom: v }))}
            />
            <Field
              label="Prénom *"
              value={draft.prenom}
              onChange={(v) => setDraft((p) => ({ ...p, prenom: v }))}
            />
            <Field
              label="Adresse *"
              value={draft.adresse}
              onChange={(v) => setDraft((p) => ({ ...p, adresse: v }))}
            />
            <Field
              label="Code postal *"
              value={draft.cp}
              onChange={(v) => setDraft((p) => ({ ...p, cp: v }))}
            />
            <Field
              label="Ville *"
              value={draft.ville}
              onChange={(v) => setDraft((p) => ({ ...p, ville: v }))}
            />

            {/* ✅ Fonction -> Select */}
            <label className="block">
              <div className="text-sm font-semibold text-slate-700 mb-1">
                Fonction
              </div>
              <select
                value={draft.fonction || ""}
                onChange={(e) =>
                  setDraft((p) => ({ ...p, fonction: e.target.value }))
                }
                className={[
                  "w-full rounded-xl px-3 py-2 ring-1 ring-slate-200 bg-white",
                  "focus:outline-none focus:ring-2 focus:ring-indigo-500  dark:bg-gray-800 dark:ring-gray-700/50 dark:focus:ring-gray-500/50",
                ].join(" ")}
              >
                {FUNCTION_OPTIONS.map((opt) => (
                  <option key={opt.value || "empty"} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </label>

            <Field
              label="Téléphone"
              value={draft.telephone}
              onChange={(v) => setDraft((p) => ({ ...p, telephone: v }))}
            />
            <Field
              label="Email"
              type="email"
              value={draft.email}
              onChange={(v) => setDraft((p) => ({ ...p, email: v }))}
            />
          </div>
        </>
      )}
    </SectionCard>
  );
}
